/* ==================================================================
   BOT & GEO GUARD
   ------------------------------------------------------------------
   CHANGELOG — IVYN Speed Fix – Aug 2026 (duplicate theme only)
   Reason: this file was the source of the "Access restricted /
   Reference: geo-PL" page. It was blocking Google Lighthouse /
   PageSpeed, and very likely Meta's ad-review and catalogue crawlers,
   making a performance baseline impossible to capture.

   Changes made:
   1. blockOutsideIndia  true -> false
      Rationale: geo check required a cross-border fetch to ipapi.co on
      EVERY pageview (incl. all ~15.5k monthly Indian sessions). Free
      tier caps at 1000 req/day then fails open, so the block was
      unreliable anyway (evidence: Finland sessions reached checkout).
      Blocked ~43 genuine NRI/Gulf sessions per month for no real gain.
      Setting this false also REMOVES the ipapi.co round trip entirely.
   2. GOOD_BOTS allowlist expanded to admit Lighthouse/PageSpeed,
      Shopify, Meta, Judge.me and uptime/SEO verification agents.
   3. blockBots LEFT ON. Headless-browser detection still has value
      against scrapers that execute JS (Puppeteer/Playwright/Selenium).

   NOTE: bot blocking here is client-side and cannot stop non-JS
   scrapers (curl, python-requests, scrapy). Edge-level blocking
   (Cloudflare) remains the correct place for that.
   ================================================================== */
(function () {
  "use strict";

  /* ----------------------------- CONFIG ----------------------------- */
  var CFG = {
    blockOutsideIndia: false,              // CHANGED (was true) — see changelog
    blockBots:         true,               // kept ON
    allowSearchBots:   true,
    allowedCountries:  "IN",
    email:             "support@ivyn.in",
    brand:             "IVYN"
  };
  /* ------------------------------------------------------------------ */

  // Never lock the store owner out of the theme editor / admin preview.
  if (window.Shopify && window.Shopify.designMode) return;

  var allowed = String(CFG.allowedCountries || "IN")
    .toUpperCase().split(",").map(function (c) { return c.trim(); });

  var ua = navigator.userAgent || "";

  // EXPANDED: legit crawlers, auditors and partner agents — never block.
  var GOOD_BOTS = /(googlebot|bingbot|slurp|duckduckbot|baiduspider|yandex|applebot|google-inspectiontool|adsbot-google|mediapartners-google|storebot-google|google-structured-data|chrome-lighthouse|pagespeed|gtmetrix|pingdom|uptimerobot|facebookexternalhit|facebookcatalog|meta-externalagent|twitterbot|linkedinbot|whatsapp|telegrambot|shopify|judge\.me|klaviyo|slackbot)/i;
  var isGoodBot = GOOD_BOTS.test(ua);

  function looksLikeBot() {
    var BAD_UA = /(bot|crawl|spider|scrape|headless|phantom|selenium|puppeteer|playwright|python-requests|curl|wget|http-client|axios|go-http|libwww|java\/|okhttp|scrapy|semrush|ahrefs|mj12|dotbot|petalbot)/i;
    if (BAD_UA.test(ua) && !isGoodBot) return true;
    if (navigator.webdriver === true) return true;
    if (/HeadlessChrome/i.test(ua)) return true;
    var noLang = !navigator.languages || navigator.languages.length === 0;
    var noPlugins = navigator.plugins && navigator.plugins.length === 0;
    if (noLang && noPlugins && /chrome|firefox|safari/i.test(ua) === false) return true;
    if (!ua) return true;
    return false;
  }

  function block(reason) {
    try { window.stop && window.stop(); } catch (e) {}

    function run() {
      var doc = document;
      doc.documentElement.innerHTML =
        '<head><meta charset="utf-8"><meta name="robots" content="noindex">' +
        '<meta name="viewport" content="width=device-width, initial-scale=1">' +
        '<title>Access restricted</title></head><body></body>';

      var body = doc.body;
      body.style.cssText = "margin:0;font-family:-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;" +
        "background:#0f1115;color:#f4f5f7;min-height:100vh;display:flex;align-items:center;justify-content:center;";

      function el(tag, css, text) {
        var n = doc.createElement(tag);
        if (css) n.style.cssText = css;
        if (text != null) n.textContent = text;
        return n;
      }

      var wrap = el("div", "max-width:520px;padding:40px 28px;text-align:center;");
      wrap.appendChild(el("div", "font-size:44px;line-height:1;margin-bottom:18px;", "\uD83D\uDD12"));
      wrap.appendChild(el("h1", "font-size:24px;margin:0 0 12px;font-weight:700;", "Access restricted"));
      wrap.appendChild(el("p", "font-size:15px;line-height:1.6;color:#c2c6cf;margin:0 0 24px;",
        "We're sorry — access to " + CFG.brand + " is currently limited in your region or from your " +
        "connection. If you believe this is a mistake, please email us and we'll be glad to help."));

      var a = el("a", "display:inline-block;background:#4f7cff;color:#fff;text-decoration:none;" +
        "padding:13px 26px;border-radius:8px;font-weight:600;font-size:15px;", "Email us: " + CFG.email);
      a.href = "mailto:" + CFG.email + "?subject=" + encodeURIComponent("Access request - " + CFG.brand);
      wrap.appendChild(a);

      wrap.appendChild(el("p", "font-size:12px;color:#7b8090;margin:22px 0 0;", "Reference: " + reason));
      body.appendChild(wrap);
    }

    if (document.body) run();
    else document.addEventListener("DOMContentLoaded", run);
  }

  // 1) Bot check (runs immediately, no network needed).
  if (CFG.blockBots) {
    if (!(CFG.allowSearchBots && isGoodBot) && looksLikeBot()) {
      return block("bot");
    }
  }

  // 2) Geo check — DISABLED via CFG.blockOutsideIndia = false.
  //    Because the flag is false this branch never runs, so lookupCountry()
  //    is never called and the ipapi.co / ipwho.is / geojs.io fetches are
  //    removed from every pageview. Code retained for easy re-enable.
  if (CFG.blockOutsideIndia && !(CFG.allowSearchBots && isGoodBot)) {
    lookupCountry(function (cc) {
      if (!cc) return; // lookup failed -> fail open (don't block real customers)
      if (allowed.indexOf(cc.toUpperCase()) === -1) {
        block("geo-" + cc);
      }
    });
  }

  function lookupCountry(cb) {
    var providers = [
      { url: "https://ipapi.co/json/",                  pick: function (d) { return d.country_code; } },
      { url: "https://ipwho.is/",                        pick: function (d) { return d.country_code; } },
      { url: "https://get.geojs.io/v1/ip/country.json",  pick: function (d) { return d.country; } }
    ];
    var i = 0;
    (function next() {
      if (i >= providers.length) return cb(null);
      var p = providers[i++];
      fetch(p.url, { cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (d) { var cc = p.pick(d); if (cc) cb(cc); else next(); })
        .catch(next);
    })();
  }
})();
